<template>
    <div class="btn-group float-end">
		<button class="btn btn-outline-light btn-sm btn-sort" type="button" role="menu" id="sortByLink" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
			<em class="icon ni ni-sort-v"></em>
			<span class="d-none d-sm-inline">Sort</span>
		</button>

      <div :class="['dropdown-menu sip-sort-menu',getConfig('direction') == 'ltr' ? 'dropdown-menu-right' : '']" aria-labelledby="sortByLink">
        <button class="dropdown-item custom-dropdown sip-sort-item" v-for="option in sortByOptions" :key="'order-'+option.value" @click="$emit('updateOrder',option.value)">
        	<span class="sip-sort-item__icon" aria-hidden="true">
        		<admin-icon :name="option.icon" :size="15"></admin-icon>
        	</span>
        	<span class="sip-sort-item__label">{{option.translation}}</span>
        	<span v-if="option.value == order" class="sip-sort-item__check"><admin-icon name="check" :size="14"></admin-icon></span>
        </button>
        <div class="dropdown-divider"></div>
        <button class="dropdown-item custom-dropdown sip-sort-item" v-for="option in orderByOptions" :key="'field-'+option.value" @click="$emit('updateSortBy',option.value)">
        	<span class="sip-sort-item__icon" aria-hidden="true">
        		<admin-icon :name="fieldIcon(option)" :size="15"></admin-icon>
        	</span>
        	<span class="sip-sort-item__label">{{option.translation}}</span>
        	<span v-if="option.value == sortBy" class="sip-sort-item__check"><admin-icon name="check" :size="14"></admin-icon></span>
        </button>
      </div>
    </div>
</template>

<script>
	const FIELD_ICONS = {
		created_at: 'clock',
		updated_at: 'clock',
		name: 'user',
		title: 'file-text',
		description: 'file-text',
		topic: 'book',
		first_name: 'user',
		last_name: 'user',
		middle_name: 'user',
		first_guardian_name: 'users',
		second_guardian_name: 'users',
		amount: 'rupee',
		price: 'rupee',
		price_per_unit: 'rupee',
		total: 'rupee',
		paid: 'wallet',
		balance: 'wallet',
		concession: 'percent',
		late: 'clock',
		quantity: 'hash',
		page: 'book',
		status: 'check-circle',
		vehicle_id: 'bus',
		vehicle: 'bus',
		registration_number: 'id-card',
		admission_number: 'hash',
		roll_number: 'hash',
		unique_identification_number: 'id-card',
		contact_number: 'phone',
		emergency_contact_name: 'phone',
		emergency_contact_number: 'phone',
		first_guardian_contact_number_1: 'phone',
		second_guardian_contact_number_1: 'phone',
		gender: 'user',
		nationality: 'globe',
		area: 'map-pin',
		present_address: 'map-pin',
		permanent_address: 'map-pin',
		house: 'home',
		blood_group: 'droplets',
		religion: 'heart',
		caste: 'users',
		category: 'tag',
		disability_type: 'heart',
		medium_instruction: 'languages',
		bpl: 'badge',
		rte: 'badge',
		entry_time: 'clock',
		log: 'clipboard-list',
		rating: 'star',
		total_fuel: 'drop',
		total_run: 'activity',
		age_integer: 'hourglass',
		min: 'chart',
		max: 'chart',
		avg: 'chart',
		owned: 'key',
		contract: 'file-text',
		active: 'check-circle',
		inactive: 'ban',
		pending: 'hourglass',
		rejected: 'x-circle',
		allotted: 'check-circle',
		parent: 'users',
		other: 'list',
		dispatch: 'send',
		receive: 'inbox',
		student: 'graduation-cap',
		employee: 'briefcase',
		incoming: 'phone',
		outgoing: 'phone',
		complete: 'check-circle',
		due: 'clock',
		overdue: 'alert'
	};

	export default {
		props: {
			sortBy: {
				required: true,
				default: 'created_at'
			},
			order: {
				required: true,
				default: 'desc'
			},
			orderByOptions: {
				required: true,
				default: []
			}
		},
		data() {
			return {
				sortByOptions: [
					{
						value: 'asc',
						translation: i18n.general.ascending,
						icon: 'sort-asc'
					},
					{
						value: 'desc',
						translation: i18n.general.descending,
						icon: 'sort-desc'
					}
				]
			}
		},
		methods: {
			getConfig(config){
				return helper.getConfig(config);
			},
			fieldIcon(option) {
				if (option && option.icon) {
					return option.icon;
				}
				return this.sortFieldIcon(option && option.value);
			},
			sortFieldIcon(value) {
				const key = String(value || '').toLowerCase();
				if (FIELD_ICONS[key]) {
					return FIELD_ICONS[key];
				}
				if (key === 'created_at' || key === 'updated_at' || key.endsWith('_at')) {
					return 'clock';
				}
				if (key.includes('time')) {
					return 'clock';
				}
				if (key.includes('date')) {
					return 'calendar';
				}
				if (key.includes('amount') || key.includes('price') || key.includes('fee') || key.includes('paid')) {
					return 'rupee';
				}
				if (key.includes('email') || key.includes('mail')) {
					return 'mail';
				}
				if (key.includes('phone') || key.includes('contact')) {
					return 'phone';
				}
				if (key.includes('address')) {
					return 'map-pin';
				}
				if (key.includes('title')) {
					return 'file-text';
				}
				if (key.includes('name')) {
					return 'user';
				}
				if (key.includes('status')) {
					return 'check-circle';
				}
				return 'list';
			}
		}
	}
</script>
